import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routesConfig";
import "./HomeStyles.css";
import ConfirmPopup from "../ConfirmNavigation/ConfirmPopup";
import SISCLogo from '../../assets/LOGO-SISC-V.png';

const Home = () => {
  const navigate = useNavigate();

  /*const handleNavigation = (path) => {
    navigate(path);
  };*/

  const slowRoutes = ["/convivencia"];
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingPath, setPendingPath] = useState("");
  const handleNavigation = (path) => {
    if (slowRoutes.includes(path)) {
      setPendingPath(path);
      setShowConfirm(true);
    } else {
      navigate(path);
    }
  };
  const handleConfirm = () => {
    setShowConfirm(false);
    if (pendingPath) navigate(pendingPath);
    setPendingPath("");
  };
  const handleCancel = () => {
    setShowConfirm(false);
    setPendingPath("");
  };

  return (
    <div className="home-container">
      <section className="home-content">
        <div className="logo-placeholder">
          <img
            src={SISCLogo}
            alt="Logo SISC"
            className="home-logo"
          />
        </div>
        <p className="home-subtext">
          Selecciona una categoría en el menú para comenzar.
        </p>
      </section>
      <aside className="home-sidebar">
        <h2 className="sidebar-title">Indicadores</h2>
        <ul className="sidebar-menu">
          {routes.map(({ path, label }) => (
            <li key={path} className="sidebar-item">
              <button
                onClick={() => handleNavigation(path)}
                className="sidebar-button"
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </aside>
      {/* Popup de confirmación */}
      <ConfirmPopup
        visible={showConfirm}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default Home;
